/**
 * A class representing a test waiter token.
 *
 * @public
 * @class
 */
export default class Token {}
